import React from 'react';
import styled from 'styled-components';

import { Spacer, Flex } from '@badi/badi-components';

import { SEEKER_USER_ROLE } from 'datamodel/User/constants';
import BookingSummaryCard from 'components/booking-summary-card';
import PaymentTodaySummary from 'components/payment-today-summary';

import { translate } from 'base/shared/Localization';

import StatusBadge from '../booking-status-badge';
import ExpirationBadge from '../booking-expiration-badge';
import BookingStepLayout from '../step-layout';
import RoomListerSummary from './room-lister-summary';
import { getStatusOnCheckoutFlow, getFormattedDate } from './utils';
import CancellationPolicyLink from './components/cancellation-policy-link';
import BadiPlusListingDetails from './components/badi-plus-listing-details';

const SummaryCardWrapper = styled.div`
  width: 100%;
`;

const PaymentCheckout = ({ title = '', bookingRequestDetail }) => {
  const {
    expirationText,
    moveIn,
    moveOut,
    price = {},
    room,
    lister,
    status,
    lengthInMonths,
    exactMonthsLength,
    bookingValue,
  } = bookingRequestDetail;

  const { method, paymentBreakdown, ...priceWithoutMethod } = price;
  const mappedStatus = getStatusOnCheckoutFlow(status);
  const isBadiPlus = room?.isBadiPlusRoom;

  const getDescription = () => {
    isBadiPlus ? '' : translate('recovery.payment_checkout_subtitle');
  };

  return (
    <BookingStepLayout
      description={getDescription()}
      sidebar={
        isBadiPlus ? (
          <BadiPlusListingDetails room={room} userRole={SEEKER_USER_ROLE} />
        ) : (
          [
            <Spacer key="room-summary" top={2}>
              <RoomListerSummary lister={lister} room={room} userRole="seeker" />
            </Spacer>,
            <Spacer key="cancellation-policy" top={4}>
              <CancellationPolicyLink />
            </Spacer>,
          ]
        )
      }
      sidebarTitle={
        isBadiPlus
          ? translate('badiplus_checkout_listing_details')
          : translate('recovery.payment_booking_request_details')
      }
      title={translate(title)}
    >
      <Spacer bottom={3}>
        <Flex gutter={1} key="badges">
          <StatusBadge status={mappedStatus} userRole={SEEKER_USER_ROLE} />
          {!!!isBadiPlus && expirationText && <ExpirationBadge expiration={expirationText} />}
        </Flex>
      </Spacer>
      {(room?.deposit || price?.fee) && (
        <PaymentTodaySummary deposit={room?.deposit} fee={price?.fee} />
      )}
      {paymentBreakdown && (
        <SummaryCardWrapper>
          <BookingSummaryCard paymentsBreakdown={paymentBreakdown} />
        </SummaryCardWrapper>
      )}
    </BookingStepLayout>
  );
};

export default PaymentCheckout;
